import { Trans, useTranslation } from 'react-i18next';
import { Icon, IconSize } from 'app/components/core/Icon';
import * as styles from './RoleAndWarehouseSelector.css';

export function NoMatchFound({ filter = null, icon = null, message = null }) {
    const { t } = useTranslation();

    return (
        <div className={styles.noMatchFound}>
            <Icon variant={icon} size={IconSize.SMALL} />
            <div>
                {message ?? (
                    <Trans
                        t={t}
                        i18nKey="components:SnowflakeConnectionStatus.list.noMatchFound"
                        components={{ span: <span /> }}
                        values={{ filter }}
                    />
                )}
            </div>
        </div>
    );
}
